export const NAVIGATE = 'NAVIGATE'
